import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['revealField']

  connect() {
    this.modal = new bootstrap.Modal(this.element, { backdrop: 'static', keyboard: false })
    this.modal.show()
  }

  disconnect() {
    this.modal?.dispose()
  }

  updateChoice(event) {
    const value = event.target.value

    this.revealFieldTargets.forEach((field) => {
      field.classList.toggle('d-none', field.dataset.revealFor !== value)
    })
  }

  hideOnSuccess(event) {
    if (event.detail.success) {
      this.modal.hide()
    }
  }
}
